module.exports = __webpack_public_path__ + "img/av226.8933b4dc.png";